import React, { Component } from 'react';
import { connect } from 'react-redux';
import './index.scss';
import Banner from '../about-me/component/banner/banner';
import PartnerBox from './component/partnerBox/partnerBox';
import { actionCreators } from './store';

class Partner extends Component {

  componentDidUpdate(preProps, prevState) {
    const { partDatas } = this.props;
    if (partDatas.size > 0) {
      const { query } = this.props.location;
      if (query && query.val) {
        const num = Number(query.val) - 1;
        const partner = document.getElementsByClassName('part-content-box')[0]
        if (partner.children[num]) {
          const x = partner.children[num].offsetTop - 100
          window.scrollTo(0, x);
        }
      }
    }
  }

  componentDidMount() {
    this.props.fetchPartData();
    this.unlisten = this.props.history.listen(route => { // 监听
      const pathArr = route.pathname.split('/')
      const { query } = route;
      if (pathArr[1] === 'partner') {
        if (query && query.val) {
          const num = Number(query.val) - 1;
          const partner = document.getElementsByClassName('part-content-box')[0]
          if (partner.children[num]) {
            const x = partner.children[num].offsetTop - 100
            window.scrollTo(0, x);
          }
        }
      }
    });
  }

  componentWillUnmount() {
    this.unlisten && this.unlisten();
  }

  render() {
    const { partDatas, head } = this.props;
    return (
      <div className="part-content">
        {
          head && <Banner title={head.get('name')} desc={head.get('des')} en={head.get('en')} bannerSrc={head.get('logo')}></Banner>
        }
        <div className="part-content-box">
          {
            partDatas.map((item) => {
              if (item.get('list').size > 0) {
                return <PartnerBox key={item.get("id")} detailOne={item}></PartnerBox>;
              }
              return null;
            })
          }
        </div>
      </div>
    )
  }
}

const mapState = (state) => ({
  partDatas: state.getIn(['partner', 'categoryList']),
  head: state.getIn(['partner', 'head'])
});

const mapDispatch = (dispatch) => ({
  fetchPartData() {
    dispatch(actionCreators.fetchPartData());
  }
});

export default connect(mapState, mapDispatch)(Partner);